import { render, staticRenderFns } from "./AdvisorDatatableOptimized.vue?vue&type=template&id=01959f38&scoped=true"
import script from "./AdvisorDatatableOptimized.vue?vue&type=script&lang=js"
export * from "./AdvisorDatatableOptimized.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDatatableOptimized.vue?vue&type=style&index=0&id=01959f38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01959f38",
  null
  
)

export default component.exports